import React from 'react';
import { BoldText } from '../BoldText';
import { validateEmailOption } from '../utils';

export const OptionDisplay = ({ option }) => {
  const getDetails = (type) => {
    const details = {
      mailgun: {
        icon: 'far fa-envelope',
        key: 'email',
        text: 'Email',
      },
      twilio: {
        icon: 'far fa-comments',
        key: 'tel',
        text: 'SMS',
      },
    };
    return details[type];
  };

  const newOptionDetails = () => {
    // Strip off the Create option label from the potential new option
    const value = option.value.replace('Add "', '').replace('"', '');
    return {
      icon: 'far fa-plus',
      key: 'label',
      text: validateEmailOption(value) ? 'Email' : 'SMS',
    };
  };

  const inputBox = document.querySelector('.ComposeModal .Select-input input');
  const searchTerm = inputBox ? inputBox.value : '';
  const details = getDetails(option.type) || newOptionDetails();
  return (
    <div className="OptionDisplay">
      <i className={`${details.icon}`}></i>{' '}
      <span className="OptionDisplay-name">
        <BoldText searchTerm={searchTerm} string={option.name} />
      </span>{' '}
      <span className="OptionDisplay-value">
        <BoldText searchTerm={searchTerm} string={option[details.key]} />
        {option.owned ? (
          <span>
            {' '}
            - <strong>Your contact</strong>
          </span>
        ) : null}
      </span>{' '}
      <span>{details.text}</span>
    </div>
  );
};
